import { BrowserModule,Title  } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule, NgbActiveModal, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedModule} from './shared/shared.module';
import {MenuItems} from './shared/menu-items/menu-items';
import {BreadcrumbsComponent} from './layout/admin/breadcrumbs/breadcrumbs.component';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './services/auth-guard.service';
import { GuestAuthGuard } from './services/guest-guard.service';
import { RoleGuard } from './services/role-guard.service';
import {ToastService} from './services/toast.service';
import {UsersService} from './services/users.service';
import { UploadFileService } from './services/upload-file.service';
import { httpInterceptorProviders } from './services/http-interceptors/index';

import {ToastyModule} from 'ng2-toasty';
import {DataTableModule} from "angular2-datatable";
// import {SearchPipe} from './_pipe/search/search.pipe';


@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    BreadcrumbsComponent,
    // SearchPipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    NgbModule,
    ToastyModule.forRoot(),
    DataTableModule,
  ],
  providers: [
    MenuItems,
    AuthService,
    UsersService,
    AuthGuard,
    GuestAuthGuard,
    RoleGuard,
    httpInterceptorProviders,
    NgbActiveModal,
    UploadFileService,
    Title
 ],
  bootstrap: [AppComponent],
  entryComponents: [
  ]
})
export class AppModule { }
